import { EXTERNAL_INELIGIBLE_STATUSES } from '../constants';
export function isExternal(account) {
    var domainDetails = account.domainDetails;
    return (domainDetails.domain === 'BANK' && domainDetails.externalAccountIndicator);
}
export function isIneligibleExternal(account) {
    return (isExternal(account) &&
        EXTERNAL_INELIGIBLE_STATUSES.includes(account.accountStatus.toLowerCase()));
}
//# sourceMappingURL=external.js.map